import { toUsCurrency } from '@hc-frontend/core-utils-format';
import Image from 'next/image';

import type { MedicareSupplementPlanSummaryContentProps } from './medicare-supplement-plan-summary-content.types';

export function MedicareSupplementPlanSummaryContent({
  planSummary,
  benefitHighlights = [],
  actionButton,
}: MedicareSupplementPlanSummaryContentProps) {
  const partADeductible = planSummary.benefits.find(
    (benefit) => benefit.type === 'PartADeductible',
  );
  const partBDeductible = planSummary.benefits.find(
    (benefit) => benefit.type === 'PartBDeductible',
  );

  let benefits;
  if (benefitHighlights.length === 0) {
    benefits = planSummary.benefits.slice(0, 3);
  } else {
    benefits = planSummary.benefits.filter((benefit) =>
      benefitHighlights.includes(benefit.type),
    );
  }

  return (
    <>
      <div className="mb-24-24 flex flex-col items-center gap-x-32-32 gap-y-16-16 laptop:flex-row">
        <Image
          src={planSummary.imageUrl}
          alt="Plan carrier image"
          width="128"
          height="128"
        />
        <div className="flex grow flex-col flex-wrap items-center gap-x-16-16 laptop:items-start">
          <span className="hc-typography--paragraph-lg text-center font-bold leading-tight laptop:text-left">
            {planSummary.title}
          </span>
        </div>
        {actionButton}
      </div>
      <div className="flex flex-row flex-wrap items-start justify-center gap-x-32-60 gap-y-16-16">
        <div className="flex flex-col flex-wrap items-center leading-tight">
          <span className="hc-typography--help-text font-bold">
            Monthly Premium
          </span>
          <span className="hc-typography--heading-one">
            {toUsCurrency(planSummary.monthlyPremium)}
          </span>
          {planSummary.monthlyPremiumCompare !== null ? (
            <p className="hc-typography--disclaimer font-bold text-error-800">
              Was{' '}
              <span className="line-through">
                {toUsCurrency(planSummary.monthlyPremiumCompare)}
              </span>
            </p>
          ) : null}
        </div>

        <div className="flex flex-col flex-wrap items-center leading-tight">
          <p className="hc-typography--help-text font-bold">
            Annual Deductible
          </p>
          <p className="hc-typography--help-text">
            <span className="hc-typography--paragraph-lg font-bold">
              {partADeductible?.value ?? 'NA'}/
            </span>
            plan A
          </p>
          <p className="hc-typography--help-text">
            <span className="hc-typography--paragraph-lg font-bold">
              {partBDeductible?.value ?? 'NA'}/
            </span>
            plan B
          </p>
        </div>

        {benefits.length > 0 && (
          <div className="grid grid-cols-2 gap-x-32-32 gap-y-4-4">
            {benefits.map((item) => (
              <p
                className={`hc-typography--help-text leading-tight ${item.applies === false ? 'line-through' : ''}`}
                key={item.type}
              >
                {item.title}
              </p>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
